import React, { Component } from 'react'
import t from '../components/Language/language'
import './ViewDetails.css'
import * as languageSettings from '../components/Language/languageSettings'
import AccountInfo from '../components/Account/AccountInfo'
import Company from '../components/Company/Company'
import 'url-search-params-polyfill'
// MyAccountContainer - Component
class MyAccountContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      toggle: true,
      showAccount: true,
      saveSuccess: false,
      currentLanguage: languageSettings.getCurrentLanguage()
    }
    this.toggleTab = this.toggleTab.bind(this)
    this.onSaveSuccess = this.onSaveSuccess.bind(this)
  }

  // after save function success change the toggle & saveSuccess states
  onSaveSuccess (e) {
    this.setState({ toggle: true, saveSuccess: true })
  }

  // Modal tab function handle and change the toggle & showAccount & saveSuccess state
  toggleTab (event) {
    if (event.target.name === 'account') {
      this.setState({ toggle: true, showAccount: true, saveSuccess: false })
    } else {
      this.setState({ toggle: false, showAccount: false, saveSuccess: false })
    }
  }

  // Main reder function
  render () {
    const language = this.state.currentLanguage
    return (
      <div className='accountsettings'>
        <div id='Navbar' className='subnav clear'>
          <ul className='subinfo'>
            <li className={this.state.toggle ? 'active_tab' : ''}><a name='account' onClick={this.toggleTab} >{t[language].accountinfo}</a></li>
            <li className={this.state.toggle ? '' : 'active_tab'}><a name='company' onClick={this.toggleTab} >{t[language].companyinfo}</a></li>
          </ul>
        </div>
        {/* check if Showaccount state is true displaying account info or displaying company info */}
        {this.state.showAccount ? <AccountInfo onSaveSuccess={this.onSaveSuccess} saveSuccess={this.state.saveSuccess} /> : <Company onSaveSuccess={this.onSaveSuccess} saveSuccess={this.state.saveSuccess} />}
      </div>
    )
  }
}

export default MyAccountContainer



// WEBPACK FOOTER //
// ./src/containers/MyAccountContainer.js